import axios from 'axios';

export const openExamSchedule = async (examFileURL) => {
    axios({
        url: examFileURL,
        method: 'GET',
        responseType: 'blob'
    }).then((response) => {
        const localUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        window.open(localUrl, '_self'); //open in the same window so safari does not block the new tab as popup
    });
};
